"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function MoveIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M22.537,11.4,19.319,8.181l-1.2,1.2,1.767,1.767H12.85V4.116l1.767,1.767,1.2-1.2L12.6,1.463a.853.853,0,0,0-1.2,0L8.181,4.681l1.2,1.2L11.15,4.116V11.15H4.116L5.883,9.383l-1.2-1.2L1.463,11.4a.852.852,0,0,0,0,1.2l3.218,3.218,1.2-1.2L4.116,12.85H11.15v7.034L9.383,18.117l-1.2,1.2L11.4,22.537a.852.852,0,0,0,1.2,0l3.218-3.218-1.2-1.2L12.85,19.884V12.85h7.034l-1.767,1.767,1.2,1.2L22.537,12.6A.852.852,0,0,0,22.537,11.4Z" })));
}
exports.default = MoveIcon;
